export default __webpack_public_path__ + "media/src/assets/images/Close-96e17b97322c9faa40c234e01a348597.svg";